export default (value) => {
    return /^([+]46)\s*(7[0-9])\s*(\d{3})\s*(\d{2})\s*(\d{2})/.test(value);
};
